import component from './notifications.component';
import service from './notifications.service';

export default angular.module('mpdx.menu.notifications', [component, service]).name;
